const bannerData = [
  {
    "image-pc":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_IPS3608_banner_pc.webp?v=1754123864",
    "image-mobile":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_IPS3608_banner_app.webp?v=1754123865",
    "sub-title":{
      "content":"AC-DC Power Supply",
      "color":"#fff"
    },
    "title":{
      "content":"FNIRSI IPS3608",
      "color":"#fff"
    },
    "description":{
      "content":"Smart Control, Precise Output, Full Protection",
      "color":"#fff"
    },
    "botton-first":{
      "text":"Shop Now",
      "background":"#129CFF",
      "color":"#fff",
      "url":"/products/ips3608"
    },
    "botton-second":{
      "text":"Learn More",
      "background":"#fff",
      "color":"#101010",
      "url":"/products/ips3608"
    }
  },
  {
    "image-pc":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPOS350P_banner_pc.webp?v=1754123864",
    "image-mobile":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_DPOS350P_banner_app-1.webp?v=1754123865",
    "sub-title":{
      "content":"4-IN-1 Digital Oscilloscope",
      "color":"#fff"
    },
    "title":{
      "content":"FNIRSI DPOS350P",
      "color":"#fff"
    },
    "description":{
      "content":"350MHz | Dual Channel | 1GSPS",
      "color":"#fff"
    },
    "botton-first":{
      "text":"Shop Now",
      "background":"#129CFF",
      "color":"#fff",
      "url":"/products/dpos350p"
    },
    "botton-second":{
      "text":"Learn More",
      "background":"#fff",
      "color":"#101010",
      "url":"/products/dpos350p"
    }
  },
  {
    "image-pc":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_GC-03_banner_pc.webp?v=1754123864",
    "image-mobile":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_GC-03_banner_app-1.webp?v=1754123865",
    "sub-title":{
      "content":"3-in-1 Radiation Detection",
      "color":"#101010"
    },
    "title":{
      "content":"FNIRSI GC-03",
      "color":"#101010"
    },
    "description":{
      "content":"Comprehensive Safety Monitoring",
      "color":"#101010"
    },
    "botton-first":{
      "text":"Shop Now",
      "background":"#129CFF",
      "color":"#fff",
      "url":"/products/gc-03"
    },
    "botton-second":{
      "text":"Learn More",
      "background":"#FFF",
      "color":"#101010",
      "url":"/products/gc-03"
    }
  },
  {
    "image-pc":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_HS-02_banner_pc.webp?v=1754123864",
    "image-mobile":"https://cdn.shopify.com/s/files/1/0694/8310/2426/files/FNIRSI_HS-02_banner_app-1.webp?v=1754123864",
    "sub-title":{
      "content":"Intelligent Soldering Iron",
      "color":"#101010"
    },
    "title":{
      "content":"FNIRSI HS-02",
      "color":"#101010"
    },
    "description":{
      "content":"Plug and play, easy to use.",
      "color":"#101010"
    },
    "botton-first":{
      "text":"Shop Now",
      "background":"#129CFF",
      "color":"#fff",
      "url":"/products/hs-02"
    },
    "botton-second":{
      "text":"Learn More",
      "background":"#FFF",
      "color":"#101010",
      "url":"/products/hs-02"
    }
  }
]